import { ContentBlockTypes } from 'api/landingPageTheme'
import { buildTranslate } from 'locales'

const t = buildTranslate(
  'cms.content.app_home_page.content.edit_block.content.helper_section'
)

type Link = {
  description: string
  url: string
}

export const links: Partial<Record<ContentBlockTypes, Link>> = {
  external_form: {
    description: t('external_form'),
    url: 'https://help.thanx.com/hc/en-us/articles/20632183015831-Jotform-Integration',
  },
  personalized_text: {
    description: t('personalized_text'),
    url: 'https://help.thanx.com/hc/en-us/articles/21256439661975-Customizable-app-home-page#h_01HT12EJT81V4S902MAP4AQ2R8',
  },
}
